<div *ngIf="isVisited">
  <p>我已經造訪這個國家公園，但是遊記正在撰寫中，請先參考官方網站</p>
  <a class="btn btn-primary" role="button" [href]="npsUrl" target="_blank">官方網站</a>
</div>
<div *ngIf="!isVisited">
  <p>我尚未造訪此國家公園，此頁面內容尚未完全，歡迎先參考官方網站</p>
  <a class="btn btn-primary" role="button" [href]="npsUrl" target="_blank">官方網站</a>
</div>
